import Vue from 'vue'
import VueRouter from 'vue-router'

import About from '../views/Activity/About.vue'
import Contact from '../views/Activity/Contact.vue'
import Dashboard from '../views/Activity/Dashboard.vue' 
import OccurrenceView from '../views/Activity/OccurrenceView.vue' 
import Login from '../views/Activity/Login.vue'
import Register from '../views/Activity/Register.vue'
//checklist
import Questions from '../views/Activity/checklist/Questions.vue'
import QuestionsList from '../views/Activity/checklist/QuestionsList.vue'
import QuestionConfig from '../views/Activity/checklist/QuestionConfig.vue'
//reports
import Reports from '../views/Activity/reports/Reports.vue'
import Report from '../views/Activity/reports/Report.vue'
import Web_Reports from '../views/Activity/reports/Web_Reports.vue'
import Whatsapp_Reports from '../views/Activity/reports/Whatsapp_Reports.vue'
import Mobile_Reports from '../views/Activity/reports/Mobile_Reports.vue'
import SMS_Reports from '../views/Activity/reports/SMS_Reports.vue'
import InterverntionDesk from '../views/Activity/reports/InterventionDesk.vue'
import MapReports from '../views/Activity/reports/MapReports.vue'
import ObserverReports from '../views/Activity/reports/ObserverReports.vue'
import SMS from '../views/Activity/reports/SMS.vue'
//Results
import Results from '../views/Activity/results/Results.vue'
import ManageResults from '../views/Activity/results/ManageResults.vue'
import GraphResults from '../views/Activity/results/GraphResults.vue'
import MapResults from '../views/Activity/results/MapResults.vue'
//Settings
import Settings from '../views/Activity/settings/Settings.vue'
import MyProfile from '../views/Activity/settings/MyProfile.vue'
import Candidates from '../views/Activity/settings/Candidates.vue'
import Parties from '../views/Activity/settings/Parties.vue'
import Occurrences from '../views/Activity/settings/Occurrences.vue'
import Countries from '../views/Activity/settings/Countries.vue'
import TraditionAuthorities from '../views/Activity/settings/TraditionAuthorities.vue'
import Centres from '../views/Activity/settings/Centres.vue'
import Constituencies from '../views/Activity/settings/Constituencies.vue'
import Regions from '../views/Activity/settings/Regions.vue'
import Districts from '../views/Activity/settings/Districts.vue'
import Observers from '../views/Activity/settings/Observers.vue'
import Reporters from '../views/Activity/settings/Reporters.vue'
import ReporterCategories from '../views/Activity/settings/ReporterCategories.vue'
import Users from '../views/Activity/settings/Users.vue'
import Wards from '../views/Activity/settings/Wards.vue'
import Permissions from '../views/Activity/settings/Permissions.vue'
import UserGroups from '../views/Activity/settings/UserGroups.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    props: true
  },
  {
    path: '/intervention/:id',
    name: 'Intervention',
    component: OccurrenceView,
    props: true
  }, 
  {
    path: '/login',
    name: 'Login',
    component: Login,
    props: true
  },
  {
    path: '/checklist',
    name: 'Checklist',
    component: Questions,
    props: true
  },
  {
    path: '/checklist/questions',
    name: 'Questionnaire',
    component: QuestionsList,
    props: true
  },
  {
    path: '/checklist/questions/configurations',
    name: 'Question Configurations',
    component: QuestionConfig,
    props: true
  },
  {
    path: '/reports',
    name: 'Reports',
    component: Reports,
    props: true
  },{
    path: '/reports/report',
    name: 'Report',
    component: Report,
    props: true
  },{
    path: '/reports/web',
    name: 'Web Reports',
    component: Web_Reports,
    props: true
  },{
    path: '/reports/whatsapp',
    name: 'Whatsapp Reports',
    component: Whatsapp_Reports,
    props: true
  },{
    path: '/reports/mobile',
    name: 'Mobile Reports',
    component: Mobile_Reports, 
    props: true
  },{
    path: '/reports/sms',
    name: 'SMS_Reports',
    component: SMS_Reports,
    props: true
  },
  {
    path: '/reports/map',
    name: 'Map Reports',
    component: MapReports,
    props: true
  },
  {
    path: '/reports/observer',
    name: 'Observer Reports',
    component: ObserverReports,
    props: true
  },
  {
    path: '/reports/sms',
    name: 'SMS',
    component: SMS,
    props: true
  },
  {
    path: '/reports/intervention',
    name: 'Intervention Desk',
    component: InterverntionDesk,
    props: true
  },
  {
    path: '/results',
    name: 'Results',
    component: Results,
    props: true
  },
  {
    path: '/results/graph',
    name: 'Graph Results',
    component: GraphResults,
    props: true
  },
  {
    path: '/results/map',
    name: 'Map Results',
    component: MapResults,
    props: true
  },
  {
    path: '/results/manage',
    name: 'Manage Results',
    component: ManageResults,
    props: true
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    props: true
  },
  {
    path: '/settings/myprofile',
    name: 'My Profile',
    component: MyProfile,
    props: true
  },
  {
    path: '/settings/permissions',
    name: 'Permissions',
    component: Permissions,
    props: true
  },
  {
    path: '/settings/user-groups',
    name: 'User Groups',
    component: UserGroups,
    props: true
  },
  {
    path: '/settings/users',
    name: 'Users',
    component: Users,
    props: true
  },
  {
    path: '/settings/candidates',
    name: 'Candidates',
    component: Candidates,
    props: true
  },
  {
    path: '/settings/parties',
    name: 'Parties',
    component: Parties,
    props: true
  },
  {
    path: '/settings/observers',
    name: 'Observers',
    component: Observers,
    props: true
  },{
    path: '/settings/reporters',
    name: 'Reporters',
    component: Reporters,
    props: true
  },{
    path: '/settings/reporters/categories',
    name: 'Reporter Categories',
    component: ReporterCategories,
    props: true
  },
  {
    path: '/settings/regions',
    name: 'Regions',
    component: Regions,
    props: true
  },
  {
    path: '/settings/districts',
    name: 'Districts',
    component: Districts,
    props: true
  },
  {
    path: '/settings/constituencies',
    name: 'Constituencies',
    component: Constituencies,
    props: true
  },
  {
    path: '/settings/wards',
    name: 'Wards',
    component: Wards,
    props: true
  },
  {
    path: '/settings/tradition-authorities',
    name: 'Tradition Authorities',
    component: TraditionAuthorities,
    props: true
  },{
    path: '/settings/centres',
    name: 'Centres',
    component: Centres,
    props: true
  },{
    path: '/settings/countries',
    name: 'Countries',
    component: Countries,
    props: true
  },{
    path: '/settings/interventions',
    name: 'Interventions',
    component: Occurrences,
    props: true
  },
  
  
 
]

const router = new VueRouter({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes,
  mode:"history"
})

export default router
